<div class="container-fluid py-4" *ngIf="permissionAccess">

  <!-- Header Section -->
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4">
    <div class="mb-3 mb-md-0">
      <h2 class="fw-semibold text-dark mb-1">Subir CSV Preapprovals</h2>
      <p class="text-secondary mb-0">Subida de archivos CSV para preapprovals</p>
    </div>
  </div>

  <!-- Upload Form Card -->
  <div class="row g-4">
    <div class="col-12 col-lg-8 col-xl-6">
      <div class="card border rounded-4 shadow-none bg-white">
        <div class="card-body p-4 p-xl-5">

          <!-- Partner Selector -->
          <div class="mb-4">
            <p class="text-secondary fw-semibold mb-3 text-uppercase"
              style="font-size: 0.75rem; letter-spacing: 0.8px;">Partner</p>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Seleccione partner</mat-label>
              <mat-select>
                <mat-option *ngFor="let partner of partners" [value]="partner.code" (click)="setPartner(partner)">
                  {{ partner.view_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- File Upload -->
          <div class="mb-4" *ngIf="partnerSelected">
            <p class="text-secondary fw-semibold mb-3 text-uppercase"
              style="font-size: 0.75rem; letter-spacing: 0.8px;">Archivo CSV <span class="text-danger">*</span></p>
            <div class="upload-zone">
              <i class="bi bi-file-earmark-spreadsheet text-secondary fs-5"></i>
              <input class="form-control" accept=".csv" type="file" (change)="getFileBufer($event)">
            </div>
          </div>

          <!-- Campaign ID -->
          <div class="mb-4" *ngIf="partnerSelected">
            <div class="campaign-card">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="campaign-title">Añadir Identificador de Campaña</p>
                  <span class="text-muted" style="font-size: 0.75rem;">Generar o asignar identificador a los
                    preapprovals</span>
                </div>
                <mat-slide-toggle [(ngModel)]="enableCampaign" color="primary"></mat-slide-toggle>
              </div>

              <!-- Opciones cuando la campaña está activada -->
              <div class="mt-3 pt-3 border-top" *ngIf="enableCampaign">
                <!-- Selector de tipo (solo MCA) -->
                <div class="d-flex align-items-center justify-content-between mb-3" *ngIf="isMcaPartner">
                  <span class="text-secondary fw-semibold text-uppercase"
                    style="font-size: 0.75rem; letter-spacing: 0.8px;">
                    {{ isCustomCampaign ? 'Identificador Personalizado' : 'Automático (Mes/Año)' }}
                  </span>
                  <mat-slide-toggle [(ngModel)]="isCustomCampaign" color="primary">
                    <span class="text-muted" style="font-size: 0.75rem;">Personalizado</span>
                  </mat-slide-toggle>
                </div>

                <!-- Mes/Año para campaña automática (MCA) -->
                <div class="row g-3" *ngIf="!isCustomCampaign && isMcaPartner">
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100 mb-0">
                      <mat-label>Mes de la campaña</mat-label>
                      <mat-select [(ngModel)]="campaignMonth">
                        <mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100 mb-0">
                      <mat-label>Año</mat-label>
                      <mat-select [(ngModel)]="campaignYear">
                        <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Input para Identificador Custom -->
                <div *ngIf="isCustomCampaign || !isMcaPartner">
                  <mat-form-field appearance="outline" class="w-100 mb-0">
                    <mat-label>Identificador de campaña custom</mat-label>
                    <input matInput [(ngModel)]="customCampaignId" placeholder="Ej. CAMP_01" maxlength="20">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="border-top pt-4">
            <button type="button" class="btn btn-primary rounded-3 px-4 fw-medium" (click)="onSentDataPerson()">
              Subir preapprovals
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>

<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>